/** L'onglet Lieux : la carte de ce qu'on peut faire autour de soi. */
export const lieux = {
  carte: 'Carte des lieux',
  filtrer: 'Filtrer les lieux',
  tout: 'Tout',
  rapproche: 'Rapproche-toi pour voir les lieux',
  recherche: 'Recherche des lieux…',
  fermer: 'Fermer',
  appeler: 'Appeler',
  chercherSurLeWeb: 'Chercher sur le web',
  chercher: 'Chercher un type d’activité',
  exemple: 'Piscine, stade…',
  effacer: 'Effacer',
  rienTrouve: 'Rien trouvé par ici',
  creerUnEvenement: 'Créer un événement ici',
  aimer: 'Aimer ce lieu',
  nePlusAimer: 'Ne plus aimer ce lieu',
  familles: {
    restos: 'Restos',
    sorties: 'Sorties',
    sport: 'Sport',
    culture: 'Culture',
    nature: 'Nature',
    commerces: 'Commerces',
  },
  categories: {
    Restaurant: 'Restaurant',
    Cafe: 'Café',
    Bakery: 'Boulangerie',
    Nightlife: 'Bar',
    Brewery: 'Brasserie',
    Winery: 'Domaine viticole',
    Distillery: 'Distillerie',
    MovieTheater: 'Cinéma',
    Theater: 'Théâtre',
    MusicVenue: 'Salle de concert',
    Bowling: 'Bowling',
    MiniGolf: 'Minigolf',
    GoKart: 'Karting',
    AmusementPark: 'Parc d’attractions',
    Stadium: 'Stade',
    Soccer: 'Football',
    Tennis: 'Tennis',
    Basketball: 'Basket',
    Swimming: 'Piscine',
    Volleyball: 'Volley',
    Golf: 'Golf',
    Skating: 'Patinoire',
    RockClimbing: 'Escalade',
    SkatePark: 'Skatepark',
    FitnessCenter: 'Salle de sport',
    Museum: 'Musée',
    Landmark: 'Monument',
    Castle: 'Château',
    Fortress: 'Fort',
    NationalMonument: 'Monument national',
    Library: 'Bibliothèque',
    Planetarium: 'Planétarium',
    Aquarium: 'Aquarium',
    Zoo: 'Zoo',
    Park: 'Parc',
    Beach: 'Plage',
    Hiking: 'Randonnée',
    NationalPark: 'Parc national',
    Marina: 'Port de plaisance',
    Store: 'Boutique',
    FoodMarket: 'Marché',
  },
};
